import { AsyncPipe } from "@angular/common";
import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InputComponent } from "@components/input/input.component";
import { SubmitButtonComponent } from "@components/submit-button/submit-button.component";
import { Observable, Subject, merge, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { BusyService } from "~app/common/components/busy/busy.service";
import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { SandningsloggItemModel } from "../../produktion.models";
import { SandningsloggTexts } from "../sandningslogg.texts";
import { SandningsloggSearchService } from "../search-panel/sandningslogg-search.service";
import { SearchResultMaskinComponent } from "../search-result-maskin/search-result-maskin.component";
import { SearchResultComponent } from "../search-result/search-result.component";

@Component({
    selector: "rask-search-panel-maskin",
    templateUrl: "./search-panel-maskin.component.html",
    styleUrls: ["./search-panel-maskin.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputComponent,
        SubmitButtonComponent,
        SearchResultMaskinComponent,
        SearchResultComponent,
        AsyncPipe
    ]
})
export class SearchPanelMaskinComponent implements OnInit {
    form = new FormGroup({
        maskinNr: new FormControl<string>("")
    });

    texts = SandningsloggTexts.texts;

    protected searchResult$: Observable<SandningsloggItemModel[]>;

    private readonly busyService = inject(BusyService);
    private readonly sandningsloggService = inject(SandningsloggSearchService);
    private readonly searchSrc = new Subject<void>();

    ngOnInit(): void {
        const search$ = this.searchSrc.pipe(
            switchMap(() => this.search())
        );

        this.searchResult$ = merge(of([]), search$);
    }

    search(): Observable<SandningsloggItemModel[]> {
        const maskinNr = this.form.get("maskinNr").value.trim();

        if(!ObjectUtils.stringHasValue(maskinNr)) {
            return of([]);
        }

        const tomDate = new Date();
        const fomDate = new Date();
        fomDate.setFullYear(tomDate.getFullYear() - 2);

        this.sandningsloggService.fetchMaskinInfo(maskinNr);

        return this.busyService.addWork(this.sandningsloggService.search({
            maskinnummer: maskinNr,
            from: DateUtils.formatDateString(fomDate, DateUtils.dateformat),
            tom: DateUtils.formatDateString(tomDate, DateUtils.dateformat)
        }));
    }

    searchClick = () => {
        this.searchSrc.next();
    };
}
